import React, { useState, useEffect } from 'react';
import { Col, Image, Row } from 'react-bootstrap';
import CSSLoader from '../../shared/cssLoader';
import { CustomButton } from '../../shared/customButton';
import styles from './customerSupport.module.scss';
import SubmitTicketModal from './submitTicketModal';
import TawkMessengerReact from '@tawk.to/tawk-messenger-react';
import { useRef } from 'react';
import { getUserData } from '../../../services/util/userSettings';

const CustomerSupport = (props) => {
    let [isPageLoading, setPageLoading] = useState(false);
    let [showTicketModal, setShowTicketModal] = useState(false);
    let [userData, setUserData] = useState({});

    const tawkMessengerRef = useRef();

    const toggleChatWindow = () => {
        tawkMessengerRef.current.toggle();
    };

    const showSubmitTicketPopup = () => {
        setShowTicketModal(true)
    }

    const handleCloseSubmitTicketPopup = () => {
        setShowTicketModal(false)
    }

    const LoadInitialData = async () => {
        setPageLoading(true);
        let respond = await getUserData();
        if (respond.success === true) {
            setUserData(respond.data);
            setPageLoading(false);
            
        } else {
            setPageLoading(false);
        }
    }

    const onLoad = () => {
        if(tawkMessengerRef && tawkMessengerRef.current){
        tawkMessengerRef.current.setAttributes({
            name: userData.user_company_name,
            email: userData.user_email,

        }, function (error) {
        });
        tawkMessengerRef.current.maximize();
    }
    };

    const openDocumentationPage = () => {
        window.open('https://hiretrace.io/documentation/overview', '_blank')?.focus();
    }

    useEffect(() => {
         LoadInitialData();
    }, [])

    return (
        <div>
            {isPageLoading === true ?
                <div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>
                :
                <div>
                    {showTicketModal == true &&
                        <SubmitTicketModal show={showTicketModal} handleClose={handleCloseSubmitTicketPopup} userData={userData} />

                    }
                    {true && 
                        <TawkMessengerReact
                        propertyId={process.env.REACT_APP_TAWK_CHAT_APP_PROPERTY_ID}
                        widgetId={process.env.REACT_APP_TAWK_CHAT_APP_WIDGET_ID}
                        ref={tawkMessengerRef}
                        onLoad={onLoad}
                        />
                    }

                    <div className={styles.accountContainerBox}>
                        <div>
                            <Row>
                                <Col sm={4} md={3} lg={2} xl={1} className="align-self-center">
                                    <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/support-live-chat-icon.png`} fluid />
                                </Col>
                                <Col className="align-self-center">
                                    <p className={styles.accountSubTopic}>Chat with an Agent</p>
                                    <p className={styles.accountDescription}>Connect with one of our agents realtime </p>
                                </Col>
                                <Col md={5} lg={4} xl={3} className="align-self-center">
                                    <CustomButton
                                        type="primaryBtn"
                                        label="Live Chat"
                                        buttonType="button"
                                        // backicon={isGoogleConnectionLoading ? <i className="fas fa-circle-notch fa-spin" aria-hidden="true"></i> : null}
                                        // disabled={isGoogleConnectionLoading || isMicrosoftConnectionLoading ? true : false}
                                        handleClick={() => toggleChatWindow()}
                                    />
                                </Col>
                            </Row>
                        </div>
                        <hr className={styles.horizontalLine} />
                        <div>
                            <Row>
                                <Col sm={4} md={3} lg={2} xl={1} className="align-self-center">
                                    <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/support-ticket-icon.png`} fluid />
                                </Col>
                                <Col className="align-self-center">
                                    <p className={styles.accountSubTopic}>Create a Ticket</p>
                                    <p className={styles.accountDescription}>Submit your issue, One of our agent will get back to you via email </p>
                                </Col>
                                <Col md={5} lg={4} xl={3} className="align-self-center">
                                    <CustomButton
                                        type="defaultBtn"
                                        label="Submit a Ticket"
                                        buttonType="button"
                                        // backicon={isMicrosoftConnectionLoading ? <i className="fas fa-circle-notch fa-spin" aria-hidden="true"></i> : null}
                                        // disabled={isMicrosoftConnectionLoading || isGoogleConnectionLoading ? true : false}
                                        handleClick={() => showSubmitTicketPopup(true)}
                                    />
                                </Col>
                            </Row>
                        </div>
                        <hr className={styles.horizontalLine} />
                        <div>
                            <Row>
                                <Col sm={4} md={3} lg={2} xl={1} className="align-self-center">
                                    <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/read-docs-icon.png`} fluid />
                                </Col>
                                <Col className="align-self-center">
                                    <p className={styles.accountSubTopic}>Read Documentation</p>
                                    <p className={styles.accountDescription}>We have a complete documentation which can guide you throughout the app.</p>
                                </Col>
                                <Col md={5} lg={4} xl={3} className="align-self-center">
                                    <CustomButton
                                        type="defaultBtn"
                                        label="Read Docs"
                                        buttonType="button"
                                        // backicon={isMicrosoftConnectionLoading ? <i className="fas fa-circle-notch fa-spin" aria-hidden="true"></i> : null}
                                        // disabled={isMicrosoftConnectionLoading || isGoogleConnectionLoading ? true : false}
                                        handleClick={() =>  openDocumentationPage()}
                                    />
                                </Col>
                            </Row>
                        </div>
                    </div>


                </div>
            }
        </div>
    )
}

export default CustomerSupport